import {Button, Form, Input, Modal, notification, Space, Upload} from "antd";
import Request from "../../utilis/api/Request";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {
    ReplyToInquiryValidation,
} from "../../utilis/tools/validation";
import Urls from "../../utilis/api/Urls";
import AuthenticatedForm from "./AuthenticatedForm";
import DefaultForm from "./DefaultForm";
import {ConvertPersianToEnglish} from "../../utilis/helpers/convertor";
import Texts from "../../utilis/defaults/Text";
import {PictureOutlined} from "@ant-design/icons";
import {RcFile, UploadFile, UploadProps} from "antd/es/upload/interface";
import {getBase64, getMergeImage} from "../../utilis/helpers/imageHelper";
import ResponseMessageHandler from "../../utilis/helpers/ResponseMessage";
import ServiceResponseTime from "../../utilis/enums/ServiceResponseTime";
import Text from "../../utilis/defaults/Text";
import AbfaLogo from "../../images/logo.png"
import ConfirmInfoModal from "../modals/ConfirmInfoModal";

const ReplyToInquiry = () => {
    const [documentBase64, setDocumentBase64] = useState('');
    const [isLoading, setLoading] = useState(false);
    const authContext = useContext(AuthContext);
    const [documentList,setDocumentList]=useState<Array<UploadFile>>([])
    const [previewOpen, setPreviewOpen] = useState(false);
    // @ts-ignore
    const token = authContext.authenticated ? null : authContext.data.token;
    // @ts-ignore
    const [data, setData] = useState(authContext.authenticated ? authContext.data : authContext.data.data);
    const DocumentProps: UploadProps = {
        fileList:documentList,
        onRemove: file => {
            const index = documentList.indexOf(file);
            const newFileList = documentList.slice();
            newFileList.splice(index, 1);
            setDocumentList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            }else {
                getBase64(file).then((base64)=>{
                    let newFile:UploadFile=file
                    newFile.thumbUrl=base64;
                    console.log(newFile)

                    setDocumentList([newFile]);
                    return  false
                })
            }

            return false;
        },
    };

    const handlePrint=(text:string,name:string,traceNumber:string,address:string,orderType:string,mobile:string)=>{
        // @ts-ignore

        // @ts-ignore
        var newWin = window.open('', '', 'height=650, width=650');
        // @ts-ignore
        newWin.document.write('');
        // @ts-ignore

        // @ts-ignore
        newWin.document.write(`
            <div style="margin-bottom: 4px;display: flex; justify-content: center;font-family:'iranSans';"><h3>اداره آب و فاضلاب مازندران</h3></div>
            <div style="border: 1px solid #5e5d5d;border-radius: 7px">
                        <p style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">${text}
        </p>
     
                <div style="direction:rtl;display: flex;justify-content: start;flex-wrap: wrap;font-family:'iranSans';">
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">نام و نام خانوادگی : ${name}</span>
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">کد رهگیری : ${traceNumber}</span>
                 <span style="padding: 10px;font-family:'iranSans';">نوع درخواست : ${orderType}</span>
                 <span style="padding: 10px;font-family:'iranSans';">موبایل : ${mobile}</span>
                 <span style="padding: 10px;font-family:'iranSans';">آدرس : ${address}</span>
        </div>
            </div>
                                   <div style="display: flex;justify-content: center;align-items: center;">
            <img style="width:250px;height: auto;margin-top: 50px; opacity: 80%" src="${AbfaLogo}" alt="">
</div>
        `);
        // @ts-ignore

        // @ts-ignore
        // @ts-ignore
        newWin.document.close();
        // @ts-ignore
        newWin.print();
    }
    const handleSubmit = (values: any) => {

        const body = {
            "Token": token,
            "Cellphone":authContext.authenticated ? authContext.user.cellphone : data.cellphone,
            "NationalCode": authContext.authenticated ? ConvertPersianToEnglish(values.nationalCode) : data.national_code,
            "PostalCode": authContext.authenticated ? ConvertPersianToEnglish(values.postalCode) : data.postal_code,
            "TelNumber": ConvertPersianToEnglish(values.tel),
            "MobileNumber": ConvertPersianToEnglish(values.mobile),
            "FileNumber": authContext.authenticated ? authContext.currentFileNumber : data.file_number,
            "FirstName": data.first_name,
            "LastName": data.last_name,
            "City": authContext.authenticated ? data.city_id : data.city,
            "Email": authContext.authenticated ? values.email : "",
            "Address": values.address ?  values.address : data.address ,
            "ConstructionDocumentPic": documentBase64,
            "Description": authContext.authenticated ? values.description : data.description,
        };
        Modal.confirm({
            direction:"rtl",
            title: 'آیا از صحت اطلاعات اطمینان دارید؟',
            content: <ConfirmInfoModal data={{...body,CityName:data.city_name}} type={"ReplyToInquiry"} />,
            onOk:()=>handleRequest(body,values),
            closable:true,
            centered:true,
            okText:"تایید و ارسال",
            cancelText:"بستن",
            width:800,
        })



    }
    const handleRequest=(body:any,values:any)=>{
        setLoading(true)
        Request(Urls.ReplyToInquiry, body).then((response:any) => {
            const key = `open${Date.now()}`;

            notification['success']({
                message:response.message,
                description: ResponseMessageHandler(ServiceResponseTime.ReplyToInquiry,response.data.trace_number),
                duration: 120,
                key:key,
                btn: <Button type="primary" size="small" onClick={() =>{handlePrint(ResponseMessageHandler(ServiceResponseTime.ReplyToInquiry,response.data.trace_number),data.first_name+" "+data.last_name,response.data.trace_number,body.Address,Text.ReplyToInquiry,values.mobile); notification.destroy()}}>
                    چاپ
                </Button>
            });
        }).catch((e) => {

            /*     notification['error']({
                     message: 'نا موفق',
                     description: 'لطفا دوباره تلاش کنید',
                     duration: 120
                 });*/
        }).finally(() => {
            setLoading(false)
        })
    }
    const [previewImage, setPreviewImage] = useState('');
    const onPreview = async (file: UploadFile) => {
        console.log(file)
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };
    const handleCancel = () => setPreviewOpen(false);
    const onFinishFailed = (error: any) => {

    }
    useEffect(() => {
        getMergeImage(documentList, (base64) => {

            setDocumentBase64(base64)
        })
    }, [documentList])
    return <>
        <Form
            name="basic"
            className="w-full flex flex-col"
            layout='vertical'
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            scrollToFirstError={true}
        >

            {authContext.authenticated && <AuthenticatedForm data={data} validationSchema={ReplyToInquiryValidation}/>}
            {!authContext.authenticated && <DefaultForm data={data} validationSchema={ReplyToInquiryValidation}/>}
            <Form.Item
                label={Texts.documentPic}
                requiredMark="optional"
                name="nationalCard">
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...DocumentProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>
            <Form.Item className="w-full mt-4">
                <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  md:w-[150px]"
                        htmlType="submit">
                    ثبت درخواست
                </Button>
            </Form.Item>
            <Modal open={previewOpen} title="تصویر" footer={null} onCancel={handleCancel}>
                <img alt="example" style={{width: '100%'}} src={previewImage}/>
            </Modal>
        </Form>

    </>
}
export default ReplyToInquiry;